module.exports = __webpack_public_path__ + "static/media/papyrus-logo.a95ad754.svg";